import NotFoundResult from './not_found_result'
export default NotFoundResult